import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const MissedPenaltyPopup = new PopupBuilder('Missed penalty', {
  incident_id: SoccerIncidentId.MissedPenalty,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
